import React from 'react';
import {
    SetUpDeviceQrCode,
    SetUpDeviceMobile,
    SetUpDeviceU2f,
    SetUpDeviceYubikey,
    SetUpDeviceYubikeyToken
} from '../components';
import { onClickTroubleManageMfa } from '@app/helpers';
import { MethodsMfa } from '@app/enums';
import { GetConfigureComponentUI } from '@app/models';
import { u2fRegister } from './';

export function getComponentUI(activeMethod: string) {
    switch (activeMethod) {
        case MethodsMfa.iPhone:
        case MethodsMfa.android:
            return React.createElement(SetUpDeviceMobile);
        case MethodsMfa.yubikey:
            return React.createElement(SetUpDeviceYubikey);
        case MethodsMfa.u2f:
            return null;
        default:
            return React.createElement(SetUpDeviceMobile);
    }
}

export function getConfigureComponentUI({
    activeMethod,
    isUserPushActivated,
    tokenSecret,
    encodedKey,
    setIsNeedExpandToken,
    setStepManageMfa,
    isNeedExpandTokenBlock,
    setIsNeedExpandTokenBlock,
    setIsDisableButtonNext,
    isNeedExpandToken,
    setPassCode,
    passCode,
    errorMessage,
    setErrorMessage,
    getMfaCredentials,
    isTokenSecretLoading,
    isTokenSecretError,
    setCompleted
}: GetConfigureComponentUI) {
    const commonProps = {
        tokenSecret,
        encodedKey,
        onClickTrouble: onClickTroubleManageMfa(setIsDisableButtonNext, setIsNeedExpandTokenBlock),
        setIsNeedExpandToken,
        isNeedExpandTokenBlock,
        isNeedExpandToken
    };
    switch (activeMethod) {
        case MethodsMfa.iPhone:
        case MethodsMfa.android:
            return React.createElement(SetUpDeviceQrCode, {
                isUserPushActivated,
                activeMethod,
                setPassCode,
                passCode,
                errorMessage,
                setErrorMessage,
                getMfaCredentials,
                isTokenSecretLoading,
                isTokenSecretError,
                ...commonProps
            });
        case MethodsMfa.yubikey:
            return React.createElement(SetUpDeviceYubikeyToken, {
                activeMethod,
                setPassCode,
                passCode,
                errorMessage,
                setErrorMessage,
                ...commonProps,
                setIsDisableButtonNext
            });
        case MethodsMfa.u2f:
            return React.createElement(SetUpDeviceU2f, {
                registrationCallback: u2fRegister(() => {
                    if (setCompleted) {
                        setCompleted();
                    }
                })
            });
        default:
            break;
    }
}
